import { observable } from "mobx";
import ChargeOrderCustomerRatingRequest from "./chargeOrderCustomerRatingRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRating {
  @observable
  rating?: ChargeOrderCustomerRatingRequest;

  @observable
  step?: number;

  @observable
  orderId?: string;

  @observable
  warning?: string;
}
